import React from 'react';
import ErroreFatale from './ErroreFatale';

/**
 * Rete di sicurezza per gli errori di render.
 *
 * Prendeva il posto `Sentry.ErrorBoundary`; tolto Sentry, il boundary resta:
 * serviva a due cose, segnalare l'errore e NON lasciare una pagina bianca, e
 * la seconda vale a prescindere. Senza, un errore in un qualunque render
 * farebbe sparire tutta l'interfaccia senza dire niente.
 *
 * `eventId` non c'è più — era l'identificativo dell'evento su Sentry — e
 * ErroreFatale lo mostra solo se presente, quindi non va toccato.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.reset = this.reset.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Resta la console del browser: è l'unico posto dove l'errore si vede.
    console.error('Errore non gestito nel render:', error, info?.componentStack);
  }

  reset() {
    this.setState({ error: null });
  }

  render() {
    if (this.state.error) {
      return <ErroreFatale error={this.state.error} resetError={this.reset} />;
    }
    return this.props.children;
  }
}
